import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import { Link } from "react-router-dom";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";
import { getOrder, getCustomerInvoicePdf } from "../../store/actions/order";
import styles from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import moment from "moment";
import "moment/locale/tr";
import CheckoutCart from "../../components/CheckoutCart";
import OrderDetailProducts from "../../components/OrderDetailProducts";
import OrderDetailInfo from "../../components/OrderDetailInfo";
import OrderDetailAdress from "../../components/OrderDetailAdress";
import OrderDetailInfoDetail from "../../components/OrderDetailInfoDetail";
import OrderDetailHistory from "../../components/OrderDetailHistory";
import OrderInvoiceSection from "../../components/OrderInvoiceSection";
import "../../styles/ModernOrderDetail.css";
moment.locale("tr");

class OrderDetail extends Component {
  componentDidMount() {
    this.props.getOrder(this.props.location.state.id);
  }

  // static getDerivedStateFromProps(props, state) {
  //   props.getOrder(props.location.state.id);
  //   return null;
  // }

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap",
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      if (!this.props.order.order) {
        return <Loading text={"Sayfa Yükleniyor..."} />;
      }

      // Sipariş adres bilgileri doğrudan order üzerinde kayıtlı
      const orderData = this.props.order.order;
      const address = {
        address_name: "Teslimat Adresi",
        full_name: ((orderData.first_name || "") + " " + (orderData.last_name || "")).trim(),
        city: orderData.city || "",
        town: orderData.town || "",
        postal_code: orderData.postal_code || "",
        address: orderData.address || "",
        phone: orderData.phone || "",
        active: true,
      };

      return (
        <React.Fragment>
          <PageTitle title={"Sipariş Detayları"} />
          <div className="modern-order-detail-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-order-detail-header">
                    <div className="order-detail-header-content">
                      <h1 className="order-detail-title">
                        <FontAwesomeIcon icon="file-invoice-dollar" />
                        Sipariş Detayları
                      </h1>
                      <p className="order-detail-subtitle">
                        Sipariş #{this.props.order.order ? this.props.order.order.c_number : ''} detaylarını görüntüleyin ve takip edin
                      </p>
                      <div className="order-detail-breadcrumb">
                        <Link to="/hesabim">Hesabım</Link>
                        {" / "}
                        <Link to="/hesabim/siparislerim">Siparişlerim</Link>
                        {" / "}
                        <span>Sipariş Detayları</span>
                      </div>
                    </div>
                  </div>

                  {this.props.order.fetching ? (
                    <div className="order-detail-loading">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">Sipariş Detayları Yükleniyor...</div>
                    </div>
                  ) : (
                    <React.Fragment>
                      {/* Sipariş Bilgileri Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="info-circle" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Sipariş Bilgileri</h3>
                            <p className="section-card-subtitle">Sipariş durumu ve temel bilgiler</p>
                          </div>
                        </div>
                        <OrderDetailInfo customer={true} {...this.props} />
                      </div>

                      {/* Teslimat Adresi Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="map-marker-alt" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Teslimat Adresi</h3>
                            <p className="section-card-subtitle">Sipariş teslimat bilgileri</p>
                          </div>
                        </div>
                        <OrderDetailAdress customer={true} address={address} />
                      </div>

                      {/* Ürünler Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="shopping-bag" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Sipariş Ürünleri</h3>
                            <p className="section-card-subtitle">Sipariş edilen ürünler ve fiyatları</p>
                          </div>
                        </div>
                        <OrderDetailProducts
                          header={true}
                          products={this.props.order.order.products.map(
                            ({ product, quantity, price }) => ({
                              ...product,
                              quantity,
                              salePrice: price,
                            })
                          )}
                          {...this.props}
                        />
                      </div>

                      {/* Ödeme Bilgileri Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="credit-card" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Ödeme Bilgileri</h3>
                            <p className="section-card-subtitle">Fiyat detayları ve ödeme özeti</p>
                          </div>
                        </div>
                        <OrderDetailInfoDetail customer={true} {...this.props} />
                      </div>

                      {/* Fatura Bilgileri Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="file-invoice" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Fatura Bilgileri</h3>
                            <p className="section-card-subtitle">Fatura durumu ve PDF önizleme</p>
                          </div>
                        </div>
                        <OrderInvoiceSection {...this.props} />
                      </div>

                      {/* Sipariş Geçmişi Kartı */}
                      <div className="modern-section-card">
                        <div className="section-card-header">
                          <div className="section-card-icon">
                            <FontAwesomeIcon icon="history" />
                          </div>
                          <div>
                            <h3 className="section-card-title">Sipariş Geçmişi</h3>
                            <p className="section-card-subtitle">Sipariş durumu değişiklikleri ve güncellemeler</p>
                          </div>
                        </div>
                        <OrderDetailHistory customer={true} {...this.props} />
                      </div>
                    </React.Fragment>
                  )}
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = { getOrder, getCustomerInvoicePdf };

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);



// WEBPACK FOOTER //
// ./src/routers/Account/order_detail.js